// extracted by mini-css-extract-plugin
export default {"back-button":"BackButton_back-button__MBoCo","back-button__label":"BackButton_back-button__label__Stalf"};